export const sortByWords = (array, sortBy, sign = 1) => array.sort((sku1, sku2) => (sku1[sortBy].localeCompare(sku2[sortBy])) * sign);

export const sortByNumber = (array, sortBy, sign = 1) => array.sort((sku1, sku2) => (sku1[sortBy] - sku2[sortBy]) * sign);

export const unescapeHTML = (value) => {
  if (value.length > 0) {
    const symbols = {
      '&nbsp;': '\u00A0',
      '&amp;': '&'
    };

    Object.keys(symbols).forEach((key) => {
      // To find and replace all occurrences
      value = value.split(key).join(symbols[key]);
    });
  }

  return value;
};

/**
 * Create object which contains html string for use it in dangerouslySetInnerHTML.
 *
 * @param {string} rawHtml Html string.
 * @returns {{ __html: string}}
 */
export const createInnerHtml = (rawHtml: string) => ({ __html: rawHtml });

export const createCardHtmlContent = (content: string): string => {
    return `<span style='text-align: ${document.dir === 'rtl' ? 'right' : 'left'}; display: flex; direction: ${document.dir}'>${content}</span>`;
};
